var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#7F7F7F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5721 7.20611V10.4577C11.327 10.3162 11.0421 10.2595 10.7614 10.2964C10.4808 10.3334 10.2203 10.4619 10.0201 10.662C9.81999 10.8621 9.69149 11.1227 9.65455 11.4033C9.61761 11.6839 9.6743 11.9689 9.81582 12.214C9.95734 12.4591 10.1758 12.6507 10.4373 12.759C10.6988 12.8673 10.9887 12.8863 11.2621 12.813C11.5354 12.7398 11.777 12.5784 11.9493 12.3538C12.1216 12.1293 12.215 11.8541 12.215 11.5711V5.09497C12.2151 5.01245 12.1953 4.93112 12.1574 4.85784C12.1194 4.78457 12.0644 4.7215 11.9969 4.67397C11.9295 4.62644 11.8516 4.59583 11.7698 4.58474C11.688 4.57365 11.6048 4.5824 11.5271 4.61025L7.41284 6.07983C7.3131 6.11559 7.22684 6.18128 7.16586 6.26793C7.10487 6.35457 7.07214 6.45794 7.07213 6.5639V11.0999C6.82704 10.9584 6.54211 10.9017 6.26153 10.9386C5.98094 10.9756 5.72038 11.104 5.52024 11.3041C5.3201 11.5042 5.19158 11.7647 5.15459 12.0453C5.1176 12.3259 5.17421 12.6108 5.31566 12.856C5.4571 13.1011 5.67547 13.2927 5.9369 13.4011C6.19833 13.5094 6.48821 13.5285 6.7616 13.4554C7.03498 13.3822 7.2766 13.2209 7.44897 12.9965C7.62135 12.772 7.71485 12.497 7.71498 12.214V8.58375L11.5721 7.20675V7.20611Z",
    fill: "#FFCA3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/music-icon.d8f6c22011c6d996e8b4a6912a232863.svg";
export { ForwardRef as ReactComponent };